import React from 'react';
import {toPriceStr} from '@/components/utils/converter';

interface ProgressBarProps {
  icon: React.ReactNode;
  label: string;
  current: number | string;
  target: number | string;
  showDecimals?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  icon,
  label,
  current,
  target,
  showDecimals = true,
}) => {
  // 格式化数值显示
  const formatValue = (value: number) => {
    if (showDecimals) {
      return toPriceStr(value);
    } else {
      // Team Size 显示纯数字，不显示千位分隔符和小数
      return value.toString();
    }
  };

  // 计算进度百分比
  const progressPercentage =
    typeof target === 'number'
      ? Math.min((Number(current) / target) * 100, 100)
      : 0;

  return (
    <div className="flex items-center gap-3 w-full">
      <div className="flex items-center gap-1">
        {icon}
        <p className="text-xs font-medium w-[5.5625rem] text-[#9E5A17]">
          {label}
        </p>
      </div>
      <div className="flex-1 h-[0.852rem] min-w-0 min-h-px overflow-hidden rounded-[0.25rem] relative">
        {/* 背景条 */}
        <div className="absolute bg-[#48351d] h-full left-0 right-0 top-0" />
        {/* 进度条 */}
        <div
          className="absolute bg-[#e0a94b] h-full left-0 top-0 transition-all"
          style={{width: `${progressPercentage}%`}}
        />
        {/* 文字 */}
        <p className="absolute font-medium text-[0.625rem] text-white text-center text-nowrap top-0 left-1/2 transform -translate-x-1/2 whitespace-pre">
          {typeof target === 'number'
            ? `${formatValue(Number(current))} / ${formatValue(target)}`
            : `${formatValue(Number(current))} / ${target}`}
        </p>
      </div>
    </div>
  );
};

export default ProgressBar;
